import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export const RecommendRow = ({
  title,
  address_level1,
  address_level2,
  qty,
  id,
  uuid,
  publisher,
}) => (
  <>
    <div className="row user-radius">
      <div className="col">
        <a
          href={`#主页/消息详情/${id}?u_id=${uuid}`}
          style={{ color: "#202529", textDecoration: "none" }}
        >
          <div className="row">
            <div className="col text-hidden">
              <strong>{title}</strong>
            </div>
          </div>
          <span className="text-muted pull-left">
            工作地点:
            {address_level1}-{address_level2}
            |人数:
            {qty}
          </span>
          <div className="pull-right ">
            <span style={{ color: "#00a4ff" }}>
              <FontAwesomeIcon icon={faChevronCircleRight} size="lg" fixedWidth />
            </span>
          </div>
          <br />
          <span>{publisher}</span>
        </a>
      </div>
    </div>
    <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
  </>
);

RecommendRow.propTypes = {
  title: PropTypes.string.isRequired,
  address_level1: PropTypes.string.isRequired,
  address_level2: PropTypes.string.isRequired,
  qty: PropTypes.string.isRequired,
  publisher: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  uuid: PropTypes.string.isRequired,
};

export function TopicCards(props) {
  const [index, setIndex] = React.useState(0);
  const toDetails = (it) => {
    location.href = `#主页/话题详情/${it.id}?u_id=${it.uuid}`;
  };

  return (
    <AutoPlaySwipeableViews index={index} onChangeIndex={setIndex}>
      {props.list.map((item) => (
        <div key={item.id} className="row mx-0 mt-2 text-center" style={{ fontSize: 11 }}>
          <div
            key={item.id}
            aria-hidden="true"
            onClick={() => toDetails(item)}
            className={`col${props.list.length < 3 ? "-4" : ""} bg-info text-light mx-1 topic-card`}
          >
            <span>{item.title}</span>
          </div>
        </div>
      ))}
    </AutoPlaySwipeableViews>
  );
}

TopicCards.propTypes = {
  list: PropTypes.arrayOf(PropTypes.any),
};

TopicCards.defaultProps = {
  list: [],
};
